import React from "react";
import { organizations } from "../mock";
import Reveal from "./Reveal";

const Organizations = () => {
  return (
    <section id="organizations" className="bg-cream">
      <div className="max-w-6xl mx-auto px-4 py-20">
        <Reveal className="text-center mb-14">
          <span className="text-xs font-bold tracking-[0.3em] uppercase text-gold">Memberships</span>
          <h2 className="font-head text-3xl sm:text-4xl uppercase tracking-wide text-navy mt-2">Professional Affiliations</h2>
          <div className="w-16 h-0.5 bg-gold mx-auto mt-4" />
        </Reveal>

        <div className="grid sm:grid-cols-3 gap-6">
          {organizations.map((o, i) => (
            <Reveal key={o.acronym} delay={(i % 3) + 1}>
              <div className="group h-full bg-white rounded-2xl border border-black/5 p-8 text-center transition-all duration-300 hover:-translate-y-1.5 hover:shadow-xl">
                <div className="w-20 h-20 mx-auto rounded-full flex items-center justify-center mb-4 font-head font-bold text-white text-lg tracking-wide" style={{ backgroundColor: o.color }}>
                  {o.acronym}
                </div>
                <span className="inline-block text-[11px] font-bold tracking-widest uppercase text-gold mb-2">{o.role}</span>
                <p className="text-sm text-gray-600 leading-relaxed opacity-90 group-hover:opacity-100 transition-opacity">{o.full}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Organizations;
